var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoomShare = function SvgRoomShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 0.5,
    fill: "#080808",
    fillOpacity: 0.3,
    rx: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7029_55033)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.766 15.023-3.578-3.578q-.444-.444-.89-.445c-.405 0-.878.308-.878 1.178v1.218c-2.6.113-5.027 1.179-6.879 3.03a10.31 10.31 0 0 0-3.04 7.341.463.463 0 0 0 .833.278c2.186-2.91 5.477-4.63 9.086-4.765v1.2c0 .868.473 1.177.878 1.177q.446-.001.89-.445l3.578-3.578c.348-.347.54-.81.54-1.306 0-.494-.192-.958-.54-1.305"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7029_55033"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.5 11h15.806v13.23H10.5z"
  })))));
};
export default SvgRoomShare;